import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUncontrolled } from 'uncontrollable';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamation, faExclamationCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { CloseButton } from '../CloseButton';
const defaultIcon = (bsStyle)=>{
    if (bsStyle.startsWith('info')) {
        return faExclamationCircle;
    } else if (bsStyle.startsWith('danger')) {
        return faExclamation;
    } else if (bsStyle.startsWith('warning')) {
        return faExclamationTriangle;
    } else if (bsStyle.startsWith('success')) {
        return faCheckCircle;
    }
    return null;
};
export const Alert = (props)=>{
    const { bsStyle = 'info', dismissible, show = true, onClose, children, icon, iconProps, ...rest } = useUncontrolled(props, {
        show: 'onClose'
    });
    const bsClass = classnames('alert', `alert-${bsStyle}`, props.className, {
        'd-flex align-items-center': icon !== 'none',
        'alert-dismissible': !!dismissible,
        fade: !!dismissible,
        show: !!dismissible
    });
    const iconClass = icon !== 'none' ? icon ? icon : defaultIcon(bsStyle) : null;
    //TODO: Animation
    if (show) {
        return /*#__PURE__*/ _jsxs("div", {
            ...rest,
            className: bsClass,
            role: "alert",
            children: [
                iconClass && /*#__PURE__*/ _jsx(FontAwesomeIcon, {
                    className: 'flex-shrink-0 me-3 alert-icon',
                    icon: iconClass,
                    fixedWidth: true,
                    size: "lg",
                    ...iconProps
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "alert-content flex-grow-1",
                    children: children
                }),
                dismissible && /*#__PURE__*/ _jsx(CloseButton, {
                    onClick: ()=>onClose && onClose()
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("div", {});
};
